import { projectRequest } from 'store/utils/request';

export const getFilesAndFoldersRequest = () =>
  projectRequest.get(`/app_configuration/directories/`, {
    params: { depth: -1 },
  });

export const getFileOrFolderRequest = data =>
  projectRequest.get(
    `/app_configuration/directories/${data.path ? `${data.path}/` : ''}items/${
      data.name
    }`,
  );

export const addFileRequest = ({ path, name }) =>
  projectRequest.post(`/app_configuration/directories/${path}/items/`, {
    name,
  });

export const addFolderRequest = ({ path, name }) =>
  projectRequest.post('/app_configuration/directories/', { path, name });

export const renameFileRequest = async data => {
  const { newName, oldFileName, path } = data;

  return projectRequest.patch(
    `/app_configuration/directories/${
      path ? `${path}/` : ''
    }items/${oldFileName}`,
    {
      name: newName,
    },
  );
};

export const renameFolderRequest = async data => {
  const { newName, path, parentPath } = data;

  return projectRequest.put(`/app_configuration/directories/${path}`, {
    name: newName,
    path: parentPath,
  });
};

export const updateFileRequest = async (path, data) =>
  projectRequest.put(`/app_configuration/entries/${path}/`, data);

export const updateFolderRequest = data =>
  projectRequest.patch('/app_configuration/directories/', data);

export const deleteFileRequest = data =>
  projectRequest.delete(
    `/app_configuration/directories/${data.path ? `${data.path}/` : ''}items/${
      data.name
    }`,
  );

export const deleteFilesRequest = async data =>
  projectRequest.post(`/app_configuration/multi/`, data);

export const deleteFolderRequest = path =>
  projectRequest.delete(`/app_configuration/directories/${path}`);

export const uploadFilesRequest = (
  files = [],
  path = '',
  shouldOverwriteFiles = 'false',
) => {
  const data = new FormData();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  for (const file of files) {
    data.append('contents', file, file.name);
  }

  data.append('overwrite_existing', shouldOverwriteFiles);

  const defaultConfig = {
    headers: {
      'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
    },
    timeout: 60000,
  };

  return projectRequest.post(
    `/app_configuration/directories${path ? `/${path}` : ''}/upload`,
    data,
    defaultConfig,
  );
};

export const updateBlobRequest = (file, data) =>
  projectRequest.patch(
    `/app_configuration/directories${file.path ? `/${file.path}` : ''}/items/${
      file.name
    }`,
    { contents: data },
  );

export const exportFilesAndFoldersRequest = data =>
  projectRequest.post(`/app_configuration/export/`, data, {
    responseType: 'blob',
    timeout: 60000,
  });

// We should call this request before getFilesAndFolder
// in order to keep in sync Flow and NewFlow
export const syncFlowFilesRequest = () => projectRequest.post(`/flow/export/`);
